import { Controller } from "@hotwired/stimulus"

const UNPUBLISHED_CLASSES = ["btn-pill-article-unpublished"]
const PUBLISHED_CLASSES = ["btn-pill-article-published"]

export default class extends Controller {
  static targets = ["button", "input", "label", "icon", "view", "featured", "publishingNow", "tooltipHost"]
  static values = { published: Boolean }

  connect() {
    this.paint()
  }

  toggle() {
    const editor = this.application.getControllerForElementAndIdentifier(this.element, "article-editor")
    if (!editor || editor.savePending) return

    if (this.publishedValue) {
      const previous = this.inputTarget.value
      this.inputTarget.value = "0"
      editor.saveThen(
        () => {
          this.publishedValue = false
          this.paint()
        },
        () => {
          this.inputTarget.value = previous
        }
      )
      return
    }

    const previous = this.inputTarget.value
    this.inputTarget.value = "1"
    this.publishingNowTarget.value = "1"
    editor.saveThen(
      () => {
        this.publishedValue = true
        this.paint()
        this.publishingNowTarget.value = "0"
      },
      () => {
        this.inputTarget.value = previous
        this.publishingNowTarget.value = "0"
      }
    )
  }

  paint() {
    const published = this.publishedValue
    const tooltip = published ? "Click to unpublish this article" : "Click to publish this article"
    this.labelTarget.textContent = published ? "Published" : "Unpublished"
    this.iconTarget.classList.toggle("fa-eye", published)
    this.iconTarget.classList.toggle("fa-eye-slash", !published)
    this.buttonTarget.classList.remove(...UNPUBLISHED_CLASSES, ...PUBLISHED_CLASSES)
    this.buttonTarget.classList.add(...(published ? PUBLISHED_CLASSES : UNPUBLISHED_CLASSES))
    this.buttonTarget.setAttribute("aria-pressed", published ? "true" : "false")
    this.buttonTarget.setAttribute("aria-label", tooltip)
    const tooltipHost = this.hasTooltipHostTarget ? this.tooltipHostTarget : this.buttonTarget
    tooltipHost.setAttribute("data-tooltip", tooltip)
    if (this.hasViewTarget) this.viewTarget.hidden = !published
    if (this.hasFeaturedTarget) this.featuredTarget.hidden = !published
  }
}
